import { render, staticRenderFns } from "./TransactionCard.vue?vue&type=template&id=3aa93892&scoped=true"
import script from "./TransactionCard.vue?vue&type=script&lang=js"
export * from "./TransactionCard.vue?vue&type=script&lang=js"
import style0 from "./TransactionCard.vue?vue&type=style&index=0&id=3aa93892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa93892",
  null
  
)

export default component.exports